import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function ETM(props) {
    return (
        <SvgIcon viewBox="0 0 56 56" {...props} >
            <circle cx="28" cy="28" r="28" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M39.6667 13H16.3333C14.5 13 13 14.5 13 16.3333V39.6667C13 41.5 14.5 43 16.3333 43H39.6667C41.5 43 43 41.5 43 39.6667V16.3333C43 14.5 41.5 13 39.6667 13ZM39.6667 39.6667H16.3333V16.3333H39.6667V39.6667ZM23 24.6667H19.6667V36.3333H23V24.6667ZM26.3333 19.6667H29.6667V36.3333H26.3333V19.6667ZM36.3333 29.6667H33V36.3333H36.3333V29.6667Z" fill="black"/>
        </SvgIcon>
    );
}